import { Component, type ReactNode } from "react";

interface SlotBoundaryState {
  failed: boolean;
}

/**
 * Silent error boundary around each slot entry: a simulated feature that
 * throws disappears from the page instead of breaking the dashboard around it.
 */
export class SlotBoundary extends Component<{ children: ReactNode }, SlotBoundaryState> {
  state: SlotBoundaryState = { failed: false };

  static getDerivedStateFromError(): SlotBoundaryState {
    return { failed: true };
  }

  render(): ReactNode {
    return this.state.failed ? null : this.props.children;
  }
}
